// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__ZnBeA","title":"Info_title__WMA2z","selects":"Info_selects__18Bmg","requiredAsterisk":"Info_requiredAsterisk__1oHAw"};